// extracted by mini-css-extract-plugin
module.exports =  {"root":"_32bbee5fda--root--sCFNE","item":"_32bbee5fda--item--PKk08","label":"_32bbee5fda--label--v_Nxk","active":"_32bbee5fda--active--zJ5NY"};